import React from 'react'
import styled from 'styled-components'

function Header() {
    return (
        <Nav>
           <Logo src="/images/mohmdLogo.png" />
           <NavMenu>
              

           </NavMenu>

          
        </Nav>
    )
}

export default Header

const Nav = styled.nav`
    height: 70px;
    background: #090b13;
    display: flex;
    align-items: center;
    padding: 0 36px;

    
    

    @media only screen and (min-width: 480px) and (max-width: 768px) {
       
        flex-direction: column;
        align-items: center;
        
    
       

       }

       @media only screen and (max-width: 479px) {

        flex-direction: column;
        align-items: center;
       
      }
`

const Logo = styled.img`
    width: 50px;
    

    @media only screen and (min-width: 480px) and (max-width: 768px) {
       
        margin: 10px;

       }

       @media only screen and (max-width: 479px) {

        margin: 10px;
      }

`
const NavMenu = styled.div`
    display: flex;
    flex 1;
    margin-left: 25px;
    align-items: center;
    padding: 36px;
    overflow-x: hidden;
    

    
    a {
        display: flex;
        align-items: center;
        padding: 0 12px;
        cursor: pointer;

        @media only screen and (min-width: 480px) and (max-width: 768px) {
       
            display: none;
             
          
           }
    
           @media only screen and (max-width: 479px) {
    
            display: none;
            
          }
    
        

        img{
            height: 20px
        }

        span {
            font-size: 13px;
            position: relative;

            &:after {
                content: "";
                height: 2px;
                background: white;
                position: absolute;
                left: 0;
                right: 0;
                bottom: -6px;
                opacity: 0;
                transform-origin: left center;
                transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
                transform: scaleX(0);
            }
        }

        &:hover {
            span:after {
                transform: scaleX(1);
                opacity: 1;
            }
        }
    }

`

